import { createContext } from 'react';

import type { Role, UserDetail } from '~/modules/settings/api/lib/schemas';

export const UserDetailContext = createContext<
  (UserDetail & { rolesByResource: Map<string, Role[]> }) | null
>(null);

UserDetailContext.displayName = 'UserDetailContext';
